/**
 * Menu JavaScript singleton module
 */

var Menu = (function($) {

  function initMenu() {
  
    $('.header-button .circle-plus').toggleClass('opened');
    $('body').toggleClass('has-nav');
  }

  function initColloquis() {
    $('.column__item .circle-plus').toggleClass('opened');
    $('.column__item .circle-plus').toggleClass('closed');
    $('.column__list').toggleClass('column__list--expanded');
    $('#column-preview').toggleClass('column--no-bg');
    $('.column__item--prefaci').toggleClass('column__item--active');
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.header').length) {
      return;
    }

    $('.header-button .circle-plus').on('click', function(){
        initMenu();
    });

    $('.column__item .circle-plus').on('click', function(){
      initColloquis();
    });

    


  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Menu.init);
